export const RunModeParam = 'runMode';

export const enum RunModes {
  standalone = 'standalone',
}
